define("shared/modifiers/autoresize", ["exports", "@ember/debug", "@ember/object", "@ember/service", "ember-modifier"], function (_exports, _debug, _object, _service, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  /**
   *
   * @class AutoresizeModifier
   * @extends Modifier
   *
   * AutoresizeModifier vertically auto resizes Textarea based on the input value.
   * Takes the dynamic value of textarea as an argument. It recalulates the height of textarea element based on its content.
   *
   * Positional Parameters:
   * @param {String} value The value passed to the textarea
   *
   * Usage:
   * Will recalculate the height only on input change
   * <Textarea @value=value {{autoresize}} />
   *
   * Will recalculate the height on any value change i.e. adding saved captions or hashtags
   * <Textarea @value=value {{autoresize @value}} />
   *
   */
  let AutoresizeModifier = _exports.default = (_class = class AutoresizeModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _defineProperty(this, "resizeElement", void 0);
    }
    modify(element) {
      (false && !(element.type === 'textarea') && (0, _debug.assert)('Must provide textarea element to autoresize', element.type === 'textarea'));
      if (element instanceof HTMLTextAreaElement && this.resizeElement === undefined) {
        this.resizeElement = element;
        this.resizeElement.addEventListener('input', this.resize);
      }
      if (this.resizeElement) {
        this.resize();
      }
    }
    resize() {
      if (!this.resizeElement) {
        return;
      }
      const element = this.resizeElement;
      element.style.height = 'auto';
      let heightOffset = 0;
      try {
        const style = window.getComputedStyle(element);
        if (style.boxSizing === 'content-box') {
          heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
        } else if (style.boxSizing === 'border-box') {
          heightOffset = element.offsetHeight - element.clientHeight;
        }
        if (isNaN(heightOffset)) {
          heightOffset = 0;
        }
        const requiredHeight = element.scrollHeight + heightOffset;
        element.style.height = `${requiredHeight}px`;
      } catch (error) {
        this.errors.log(`Error resizing textarea ${error}`);
      }
    }
    willRemove() {
      if (this.resizeElement) {
        this.resizeElement.removeEventListener('input', this.resize);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "resize", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resize"), _class.prototype)), _class);
});